// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__+hZCk","dark":"BaseLayout_dark__B2VbH","light":"BaseLayout_light__E1AgY"};